import { useEffect } from 'react';

import type { Post } from '~/interfaces/post';

import type { SetCookieOptions } from '../useUtils/useCookies';

interface Props {
  visitToken: string;
  post: Post;
  pageViews: string;
  setCookie: (options: SetCookieOptions) => void;
  cookiesSet: boolean;
}

const useCreatePageView = ({ visitToken, post, pageViews, setCookie, cookiesSet }: Props) => {
  const pageView = pageViews?.includes(post?.id);

  const shouldCreatePageView = cookiesSet && visitToken && post?.id && !pageView;
  const cookieKey = 'page_view';

  useEffect(() => {
    if (shouldCreatePageView) {
      const referrer = document.referrer;
      const formData = new FormData();
      formData.append('postId', post.id);
      formData.append('webTitle', post.web_title);
      formData.append('slug', post.slug);
      formData.append('landingPage', window.location.href);
      formData.append('referrer', referrer);
      formData.append('visitToken', visitToken);
      const newPageViews = pageViews ? `${pageViews},${post.id}` : post.id;

      // we don't care about the result, so if it fails, just log the error
      fetch('/page_view', { method: 'post', body: formData }).catch((error) => {
        console.error(error);
      });
      const tenMinutes = 600000 / (24 * 60 * 60 * 1000);
      setCookie({ name: cookieKey, value: newPageViews, days: tenMinutes });
    }
  }, [shouldCreatePageView]);
};

export default useCreatePageView;
